module.exports = __webpack_public_path__ + "static/img/qudi (10).66117d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (10).jpg
// module id = lJ7s
// module chunks = 0